import React from 'react';
import { motion } from 'framer-motion';
import medicinaOcupacional from '../../assets/images/mediciaocupacional.png';
import segurancaTrabalho from '../../assets/images/segurancatrabalho.png';
import treinamentos from '../../assets/images/treinos.png';
import assessoriaConsultoria from '../../assets/images/assessoriasst.png';
import exameSeg from '../../assets/images/exames.png';
import eSocial from '../../assets/images/esocial.png';

const serviceCards = [
  {
    id: 1,
    title: 'Medicina Ocupacional',
    description: 'Realizamos a Gestão completa da Saúde Ocupacional de sua empresa, atuando na prevenção de doenças no exercício profissional visando a melhoria e o controle da qualidade de vida e saúde de seus colaboradores.',
    image: medicinaOcupacional,
    link: '#medicina-ocupacional',
  },
  {
    id: 2,
    title: 'Assessoria e Consultoria em Segurança do Trabalho',
    description: 'Realizamos a Gestão completa da Segurança do Trabalho, atendendo a todas as Normas Regulamentadoras exigidas a sua empresa, visando atuar em caráter preventivo, minimizando os riscos de acidentes de trabalho, doenças ocupacionais e desta forma proteger a integridade física e a saúde do trabalhador.',
    image: assessoriaConsultoria,
    link: '#assessoria-consultoria',
  },
  {
    id: 3,
    title: 'Treinamentos',
    description: 'A legislação vigente contém muitas exigências que devem ser seguidas pelas empresas, entre elas os Treinamentos relacionados à Segurança do Trabalho. A FOCOSEG possui estrutura para atendimento de qualquer demanda de treinamentos sob medida, no local desejado e em todo Rio de Janeiro.',
    image: treinamentos,
    link: '#treinamentos',
  },
  {
    id: 4,
    title: 'Exames Ocupacionais',
    description: 'Os exames ocupacionais são exames médicos, que possuem objetivo de avaliar a saúde do trabalhador antes, durante e ao fim do seu vínculo com sua empresa, fazendo parte do PCMSO e regulamentados pela NR 07. Na FOCOSEG realizamos exames Clínico e Complementares: Admissional, Periódico, Retorno ao Trabalho, Mudança de Função e Demissional.',
    image: exameSeg,
    link: '#exames-ocupacionais',
  },
  {
    id: 5,
    title: 'e-Social',
    description: 'O Projeto eSocial unifica e informatiza o envio de diversas informações fiscais, tributárias, previdenciárias e trabalhistas para o Governo Federal, como vínculos, contribuições previdenciárias, folha de pagamento, FGTS e alguns eventos relacionados a SST. A FOCOSEG está preparada com sistema informatizado para envio dos Eventos de SST da sua empresa.',
    image: eSocial,
    link: '#esocial',
  },
  {
    id: 6,
    title: 'Segurança do Trabalho',
    description: 'A elaboração, implantação e gerenciamento de Programas de Engenharia e Segurança do Trabalho traduzem a preocupação que sua empresa possui com a segurança, bem estar e qualidade de vida de seus funcionários. A FOCOSEG tem a solução para melhor atender as necessidades de sua Empresa, disponibilizando serviços que visam minimizar os acidentes de trabalho, doenças ocupacionais, bem como proteger a integridade e capacidade do trabalhador.',
    image: segurancaTrabalho,
    link: '#seguranca-trabalho',
  },
];

const Services = () => {
  return (
    <section id="servicos" className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-800 mb-4">Conheça alguns de nossos serviços</h2>
          <div className="w-20 h-1 bg-focoseg-green mx-auto"></div>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {serviceCards.map((service) => (
            <motion.div
              key={service.id}
              className="bg-white rounded-lg shadow-lg overflow-hidden"
              whileHover={{ y: -10, transition: { duration: 0.3 } }}
            >
              <div className="h-48 overflow-hidden">
                <img 
                  src={service.image} 
                  alt={service.title} 
                  className="w-full h-full object-cover transition-transform duration-500 hover:scale-110"
                />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-800 mb-3">{service.title}</h3>
                <p className="text-gray-600 mb-4">{service.description}</p>
                <a 
                  href="https://wa.link/7rvgpy" 
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center bg-focoseg-green hover:bg-green-600 text-white font-semibold py-2 px-4 rounded transition duration-300"
                >
                  <span>Entre em contato</span>
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 ml-2" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
                  </svg>
                </a>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;